'use es6';

import Actions from 'AdsUI/lib/Actions';
import { Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import LeadSyncingEntityRecord from 'AdsUI/records/LeadSyncingEntityRecord'; // Pages fetched using the primary user. Safe for use outside of ad creation.

const PagesReducer = (state = ImmutableMap(), action) => {
  switch (action.type) {
    case Actions.PAGES_FETCH_SUCCEEDED:
      {
        if (!action.payload) {
          return state;
        }

        const {
          network,
          accountId,
          entities
        } = action.payload;
        return state.setIn([network, accountId], ImmutableSet(entities.map(entity => LeadSyncingEntityRecord.fromCreationEntity(entity, network))));
      }

    default:
      {
        return state;
      }
  }
};

export default PagesReducer;